import _ from "lodash";
export const getCleanNameOption = (str, removeIncludes = false) => {
  // Remove all special characters except underscore
  let newString = _.replace(str, /[^a-zA-Z0-9_]/g, "");
  if (removeIncludes) {
    newString = _.replace(newString, "_INITIAL", "");
  }
  return newString;
};
